import { render, staticRenderFns } from "./AdminPrivacy.vue?vue&type=template&id=f28f7df6"
import script from "./AdminPrivacy.vue?vue&type=script&lang=js"
export * from "./AdminPrivacy.vue?vue&type=script&lang=js"
import style0 from "./AdminPrivacy.vue?vue&type=style&index=0&id=f28f7df6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports